module.exports = __webpack_public_path__ + "static/media/icon1.83b7c142.svg";